import { Step } from "./components/Step";
import { StepperWrapper } from "./components/StepperWrapper";

// Create namespace for components
export const WizardStepper = {
  Step,
  StepperWrapper
};

// Export types
export * from "./types";
